module.exports = __webpack_public_path__ + "static/media/success_upload.882fdac9.png";